/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';
import {
    type PermissionResponse,
    PermissionResponseFromJSON,
    PermissionResponseToJSON,
} from '../models/PermissionResponse';
import {
    type ResourceFilter,
    ResourceFilterFromJSON,
    ResourceFilterToJSON,
} from '../models/ResourceFilter';
import {
    type RoleConsumptionResponse,
    RoleConsumptionResponseFromJSON,
    RoleConsumptionResponseToJSON,
} from '../models/RoleConsumptionResponse';
import {
    type RoleCreateRequest,
    RoleCreateRequestFromJSON,
    RoleCreateRequestToJSON,
} from '../models/RoleCreateRequest';
import {
    type RoleResponse,
    RoleResponseFromJSON,
    RoleResponseToJSON,
} from '../models/RoleResponse';
import {
    type RoleResponsePagedResult,
    RoleResponsePagedResultFromJSON,
    RoleResponsePagedResultToJSON,
} from '../models/RoleResponsePagedResult';
import {
    type RoleSearchOrderBy,
    RoleSearchOrderByFromJSON,
    RoleSearchOrderByToJSON,
} from '../models/RoleSearchOrderBy';
import {
    type RoleSearchRequest,
    RoleSearchRequestFromJSON,
    RoleSearchRequestToJSON,
} from '../models/RoleSearchRequest';
import {
    type RoleUpdateRequest,
    RoleUpdateRequestFromJSON,
    RoleUpdateRequestToJSON,
} from '../models/RoleUpdateRequest';
import {
    type SortOrder,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models/SortOrder';
import {
    type UserType,
    UserTypeFromJSON,
    UserTypeToJSON,
} from '../models/UserType';

export interface ApiRolesCheckusageGetRequest {
    id?: any;
}

export interface ApiRolesGetRequest {
    pageNumber?: any;
    pageSize?: any;
    sortOrder?: SortOrder;
    orderField?: RoleSearchOrderBy;
    applicationId?: string;
    applicationIds?: Array<string>;
    isGlobal?: boolean;
    textFilter?: string;
    roleId?: any;
    permissionId?: any;
    userType?: UserType;
    canBeRequestedByUser?: boolean;
    userId?: string;
    resourceFilter?: ResourceFilter;
    requireUserOrganizationInMinSide?: boolean;
}

export interface ApiRolesIdDeleteRequest {
    id: number;
}

export interface ApiRolesIdPermissionsGetRequest {
    id: number;
}

export interface ApiRolesIdPutRequest {
    id: number;
    roleUpdateRequest: RoleUpdateRequest;
}

export interface ApiRolesPostRequest {
    roleCreateRequest: RoleCreateRequest;
}

export interface ApiRolesSearchesPostRequest {
    roleSearchRequest: RoleSearchRequest;
}

export interface GetRolebyIdRequest {
    id: number;
}

/**
 * 
 */
export class RolesApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiRolesCheckusageGet without sending the request
     */
    async apiRolesCheckusageGetRequestOpts(requestParameters: ApiRolesCheckusageGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/roles/checkusage`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiRolesCheckusageGetRaw(requestParameters: ApiRolesCheckusageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleConsumptionResponse>> {
        const requestOptions = await this.apiRolesCheckusageGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleConsumptionResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiRolesCheckusageGet(requestParameters: ApiRolesCheckusageGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleConsumptionResponse> {
        const response = await this.apiRolesCheckusageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiRolesGet without sending the request
     */
    async apiRolesGetRequestOpts(requestParameters: ApiRolesGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['SortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orderField'] != null) {
            queryParameters['OrderField'] = requestParameters['orderField'];
        }

        if (requestParameters['applicationId'] != null) {
            queryParameters['ApplicationId'] = requestParameters['applicationId'];
        }

        if (requestParameters['applicationIds'] != null) {
            queryParameters['ApplicationIds'] = requestParameters['applicationIds'];
        }

        if (requestParameters['isGlobal'] != null) {
            queryParameters['IsGlobal'] = requestParameters['isGlobal'];
        }

        if (requestParameters['textFilter'] != null) {
            queryParameters['TextFilter'] = requestParameters['textFilter'];
        }

        if (requestParameters['roleId'] != null) {
            queryParameters['RoleId'] = requestParameters['roleId'];
        }

        if (requestParameters['permissionId'] != null) {
            queryParameters['PermissionId'] = requestParameters['permissionId'];
        }

        if (requestParameters['userType'] != null) {
            queryParameters['UserType'] = requestParameters['userType'];
        }

        if (requestParameters['canBeRequestedByUser'] != null) {
            queryParameters['CanBeRequestedByUser'] = requestParameters['canBeRequestedByUser'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['UserId'] = requestParameters['userId'];
        }

        if (requestParameters['resourceFilter'] != null) {
            queryParameters['ResourceFilter'] = requestParameters['resourceFilter'];
        }

        if (requestParameters['requireUserOrganizationInMinSide'] != null) {
            queryParameters['RequireUserOrganizationInMinSide'] = requestParameters['requireUserOrganizationInMinSide'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/roles`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiRolesGetRaw(requestParameters: ApiRolesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleResponsePagedResult>> {
        const requestOptions = await this.apiRolesGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiRolesGet(requestParameters: ApiRolesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleResponsePagedResult> {
        const response = await this.apiRolesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiRolesIdDelete without sending the request
     */
    async apiRolesIdDeleteRequestOpts(requestParameters: ApiRolesIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiRolesIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/roles/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiRolesIdDeleteRaw(requestParameters: ApiRolesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiRolesIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiRolesIdDelete(requestParameters: ApiRolesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiRolesIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiRolesIdPermissionsGet without sending the request
     */
    async apiRolesIdPermissionsGetRequestOpts(requestParameters: ApiRolesIdPermissionsGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiRolesIdPermissionsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/roles/{id}/permissions`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiRolesIdPermissionsGetRaw(requestParameters: ApiRolesIdPermissionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionResponse>> {
        const requestOptions = await this.apiRolesIdPermissionsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PermissionResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiRolesIdPermissionsGet(requestParameters: ApiRolesIdPermissionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionResponse> {
        const response = await this.apiRolesIdPermissionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiRolesIdPut without sending the request
     */
    async apiRolesIdPutRequestOpts(requestParameters: ApiRolesIdPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiRolesIdPut().'
            );
        }

        if (requestParameters['roleUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'roleUpdateRequest',
                'Required parameter "roleUpdateRequest" was null or undefined when calling apiRolesIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/roles/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RoleUpdateRequestToJSON(requestParameters['roleUpdateRequest']),
        };
    }

    /**
     */
    async apiRolesIdPutRaw(requestParameters: ApiRolesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleResponse>> {
        const requestOptions = await this.apiRolesIdPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiRolesIdPut(requestParameters: ApiRolesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleResponse> {
        const response = await this.apiRolesIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiRolesPost without sending the request
     */
    async apiRolesPostRequestOpts(requestParameters: ApiRolesPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roleCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'roleCreateRequest',
                'Required parameter "roleCreateRequest" was null or undefined when calling apiRolesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/roles`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoleCreateRequestToJSON(requestParameters['roleCreateRequest']),
        };
    }

    /**
     */
    async apiRolesPostRaw(requestParameters: ApiRolesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleResponse>> {
        const requestOptions = await this.apiRolesPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiRolesPost(requestParameters: ApiRolesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleResponse> {
        const response = await this.apiRolesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiRolesSearchesPost without sending the request
     */
    async apiRolesSearchesPostRequestOpts(requestParameters: ApiRolesSearchesPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roleSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'roleSearchRequest',
                'Required parameter "roleSearchRequest" was null or undefined when calling apiRolesSearchesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/roles/searches`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoleSearchRequestToJSON(requestParameters['roleSearchRequest']),
        };
    }

    /**
     */
    async apiRolesSearchesPostRaw(requestParameters: ApiRolesSearchesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleResponsePagedResult>> {
        const requestOptions = await this.apiRolesSearchesPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiRolesSearchesPost(requestParameters: ApiRolesSearchesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleResponsePagedResult> {
        const response = await this.apiRolesSearchesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getRolebyId without sending the request
     */
    async getRolebyIdRequestOpts(requestParameters: GetRolebyIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getRolebyId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/roles/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getRolebyIdRaw(requestParameters: GetRolebyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleResponse>> {
        const requestOptions = await this.getRolebyIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleResponseFromJSON(jsonValue));
    }

    /**
     */
    async getRolebyId(requestParameters: GetRolebyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleResponse> {
        const response = await this.getRolebyIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
